import React from 'react';
import Flatpickr from 'react-flatpickr';

import './Datepicker.css';

const Datepicker = ({placeholder, isRequired, setDate, options, value}) => {
  return (
    <Flatpickr
      key={JSON.stringify(options)}
      type="text"
      className="datePicker"
      placeholder={placeholder}
      required={isRequired}
      data-testid="date-pickup-popup"
      onChange={(e) => {
        setDate(e);
      }}
      value={value}
      options={options}
    />
  );
};

export default Datepicker;
